import { Link } from "react-router-dom";
import { Star } from "lucide-react";

/**
 * MidPageCTA — a slim, restrained conversion band placed after the
 * ArchiveStrip. Catches readers who have spent time on the editorial
 * blocks above and are ready to act, without forcing a scroll to
 * footer. One italic line + one brass button + one supporting phone
 * number. No decoration beyond the bronze star and hairline rules.
 */
export default function MidPageCTA() {
  return (
    <section
      className="bg-navy grain grain-dark py-14 md:py-16 relative overflow-hidden"
      data-testid="mid-page-cta-section"
    >
      {/* Faint hairline framing */}
      <div
        aria-hidden="true"
        className="absolute inset-x-6 top-0 h-px bg-brass/40"
      />
      <div
        aria-hidden="true"
        className="absolute inset-x-6 bottom-0 h-px bg-brass/25"
      />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
          {/* Left rail — bronze star, kicker, italic invitation */}
          <div className="flex-1">
            <div className="flex items-baseline gap-3">
              <Star size={9} className="text-brass fill-brass" />
              <div className="text-[10px] uppercase tracking-[0.36em] text-brass font-medium">
                A Private Invitation
              </div>
            </div>
            <p
              className="mt-4 font-cormorant italic text-ivory leading-[1.15]"
              style={{ fontSize: "clamp(1.5rem, 2.6vw, 2.25rem)" }}
              data-testid="mid-cta-headline"
            >
              If any of this reads like your matter,{" "}
              <span className="text-brass">the counsel table is open.</span>
            </p>
            <p className="mt-3 text-[13px] md:text-sm text-ivory/70 font-light leading-relaxed max-w-2xl">
              A confidential conference. Same-day response. Frisco headquarters,
              or by secure video across the state of Texas.
            </p>
          </div>

          {/* Right rail — brass button + phone anchor */}
          <div className="flex flex-col items-start md:items-end gap-4 shrink-0">
            <Link
              to="/intake"
              className="btn-brass inline-flex items-center gap-2"
              data-testid="mid-cta-schedule"
            >
              <Star size={11} className="fill-current" />
              Schedule a Confidential Conference
            </Link>
            <a
              href="tel:+19727121515"
              className="text-[10px] uppercase tracking-[0.32em] text-ivory/70 hover:text-brass transition-colors font-medium border-b border-brass/30 hover:border-brass pb-1"
              data-testid="mid-cta-phone"
            >
              or call (972) 712-1515
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
